import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  routes: [{
      path: '/',
      name: 'index',
      redirect: '/index'
    },{
      path: '/index',
      name: 'index',
      component: () => import('./views/index/index.vue')
    },{
      path: '/detail-sjzlpt',
      name: 'detail-sjzlpt',
      component: () => import('./views/detail_sjzlpt/index.vue')
    },{
      path: '/detail-sjzt',
      name: 'detail-sjzt',
      component: () => import('./views/detail_sjzt/index.vue')
    },{
      path: '/detail-htbi',
      name: 'detail-htbi',
      component: () => import('./views/detail_htbi/index.vue')
    },{
      path: '/detail-wyddm',
      name: 'detail-wyddm',
      component: () => import('./views/detail_wyddm/index.vue')
    },{
      path: '/case-list',
      name: 'case-list',
      component: () => import('./views/case_list/index.vue')
    },{
      path: '/case-detail',
      name: 'case-detail',
      component: () => import('./views/case_detail/index.vue')
    },{
      path: '/solution-detail',
      name: 'solution-detail',
      component: () => import('./views/solution_detail/index.vue')
    },{
      path: '/about',
      name: 'about',
      component: () => import('./views/about/index.vue')
    },{
      path: '/recruitment',
      name: 'recruitment',
      component: () => import('./views/recruitment/index.vue')
    },{
      path: '/recruitment-detail',
      name: 'recruitment-detail',
      component: () => import('./views/recruitment_detail/index.vue')
    },
    {
      path: '/solution-ppt-detail',
      name: 'solution-ppt-detail',
      props: true,
      component: () => import('./views/solution_ppt_detail/index.vue')
    },
  ],
  scrollBehavior() {
    // 返回期望滚动的位置
    return { x: 0, y: 0 } // 每次路由切换都滚动到顶部
  }
})

// router.beforeEach((to, from, next) => {
//   // 判断是否需要登录权限
//   if (to.matched.some(res => res.meta.requireAuth)) {
//     // 判断是否登录
//     if (sessionStorage.getItem('token')) {
//       next()
//     } else {
//       // 没登录则跳转到登录界面
//       next({
//         path: '/login',
//         query: {
//           redirect: to.fullPath
//         }
//       })
//     }
//   } else {
//     next()
//   }
// })

export default router